import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=24a7d6e4&scoped=true&"
import script from "./CouponPage.vue?vue&type=script&lang=ts&"
export * from "./CouponPage.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPage.vue?vue&type=style&index=0&id=24a7d6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7d6e4",
  null
  
)

export default component.exports